import React, {useCallback, useRef, useState} from 'react';
import ContentEditable from 'react-contenteditable';
import {useLayer} from '@craftjs/layers';
import {useEditor} from '@craftjs/core';
import {useClickOutsideOf} from 'hooks';
import {classNames} from 'utils';

interface IEditorLayersNameProps {
  selected: boolean;
}

const EditorLayersName = ({selected}: IEditorLayersNameProps) => {
  const {id} = useLayer();
  const {displayName, actions} = useEditor(state => ({
    displayName: state.nodes[id]?.data?.custom?.displayName ? state.nodes[id].data.custom.displayName : state.nodes[id]?.data?.displayName,
    hidden: state.nodes[id] && state.nodes[id].data.hidden,
  }));

  const ref = useRef<HTMLDivElement>(null);
  const [disabled, setDisabled] = useState(true);

  useClickOutsideOf(
    ref,
    useCallback(() => {
      if (!selected) {
        setDisabled(true);
      }
    }, [selected]),
    !disabled,
  );

  return (
    <div
      ref={ref}
      className={classNames('w-full text-sm truncate select-none', selected ? 'cursor-text' : 'bg-transparent')}
      onClick={() => {
        if (selected) {
          setDisabled(false);
        }
      }}>
      <ContentEditable
        html={displayName}
        disabled={disabled}
        tagName="p"
        onChange={e => {
          actions.setCustom(id, custom => (custom.displayName = e.target.value));
        }}
      />
    </div>
  );
};

export default React.memo(EditorLayersName);
